export const fragenEinsData = [
  {
    question: "Alter",
    answer: (
      <>
        <p>
          Der Wert eines Gebrauchtwagens sinkt in den ersten drei Jahren nach
          der Zulassung erheblich, wobei der Wertverlust im ersten Jahr
          typischerweise am stärksten ist. Danach setzt sich die Abschreibung
          jährlich fort, jedoch in einem langsameren Tempo.
        </p>
      </>
    ),
  },
  {
    question: "Kilometerstand",
    answer: (
      <>
        <p>
          Der Kilometerstand ist der Hauptgrund dafür, dass der Wert deines
          Autos mit der Zeit sinkt, und ein hoher Kilometerstand wirkt sich
          negativ auf das Angebot potenzieller Käufer aus. Wenn das Auto
          regelmäßig gefahren wird, steigt der Kilometerstand stetig an und ist
          oft ein Indikator für den allgemeinen Verschleiß des Fahrzeugs.“
        </p>
      </>
    ),
  },
  {
    question: "Servicehistorie",
    answer: (
      <>
        <p>
          Eine aktuelle Servicehistorie ist entscheidend für eine präzise
          Fahrzeugbewertung online. Beim Verkauf erzielt ein Gebrauchtwagen mit
          vollständiger Servicehistorie einen höheren Wert als dasselbe Auto mit
          lückenhafter oder fehlender Historie. Große Lücken in den
          Serviceaufzeichnungen? Käufer gehen oft vom Schlimmsten aus und bieten
          daher einen niedrigeren Preis.
        </p>
      </>
    ),
  },
  {
    question: "Marktnachfrage",
    answer: (
      <>
        <p>
          Die Marktnachfrage kann die Fahrzeugbewertung erheblich beeinflussen.
          Sie hängt von vielen Faktoren ab, darunter das Angebot und die
          Nachfrage nach bestimmten Marken und Modellen, veränderte
          Verbrauchertrends, wirtschaftliche Bedingungen und – im Zuge der
          Elektrifizierung – sogar Emissionsstandards und politische Faktoren.
        </p>
        <p>
          Der kürzliche Mangel an Computerchips und die damit verbundene
          Verlangsamung der Neuwagenproduktion haben ebenfalls zur Folge, dass
          weltweit weniger Neuwagen produziert werden – viele Käufer wenden sich
          daher dem Gebrauchtwagenmarkt zu, um hochwertige Autos mit geringer
          Kilometerleistung zu finden.
        </p>
      </>
    ),
  },
  {
    question: "Kraftstoffart",
    answer: (
      <>
        <p>
          Der geplante Umstieg auf emissionsfreie Neufahrzeuge ab 2035
          beschäftigt viele Autobesitzer, da der Wert von Verbrennungsmotoren in
          den kommenden Jahren stark schwanken könnte, wenn Elektrofahrzeuge und
          andere emissionsfreie Alternativen immer beliebter werden. Kurzfristig
          ist die Zukunft von Benzin-, Diesel- und Hybridfahrzeugen schwer
          vorherzusagen – den zukünftigen Wert eines Gebrauchtwagens genau
          einzuschätzen, ist sogar noch schwieriger.
        </p>
      </>
    ),
  },
  {
    question: "Modifikationen",
    answer: (
      <>
        <p>
          Die große Mehrheit der Käufer sucht kein modifiziertes Auto.
          Kosmetische Veränderungen, Änderungen an der Karosserie, im Innenraum
          oder am Motor können daher die Autobewertung negativ beeinflussen, da
          viele Käufer – insbesondere Autohändler – nach Fahrzeugen mit breitem
          Käuferinteresse suchen.
        </p>
      </>
    ),
  },
  {
    question: "Anzahl der Vorbesitzer",
    answer: (
      <>
        <p>
          Je mehr Vorbesitzer ein Auto hatte, desto geringer wird sein Wert
          sein. Die meisten professionellen Käufer bevorzugen Gebrauchtwagen mit
          nur einem Vorbesitzer seit der Zulassung. Oft spiegelt die Anzahl der
          Vorbesitzer auch das Alter und den Zustand eines Autos wider.
        </p>
      </>
    ),
  },
  {
    question: "Unfallhistorie",
    answer: (
      <>
        <p>
          Auch wenn ein Fahrzeug nach einem Unfall vollständig repariert wurde,
          kann eine solche Historie die Autobewertung beeinflussen. Schwere
          Unfälle oder Überschwemmungsschäden mindern oft den Wert, da viele
          professionelle Gebrauchtwagenkäufer lieber Fahrzeuge ohne Vorschäden
          bevorzugen. Dennoch gibt es Interessenten für reparierte Autos, und in
          manchen Fällen kann der Wagen weiterhin einen fairen Marktwert
          erzielen.
        </p>
      </>
    ),
  },
];

export const fragenZweiData = [
  {
    question: "Fahrzeugzustand",
    answer: (
      <>
        <p>
          Obwohl der Kilometerstand ein guter Indikator für den Zustand eines
          Autos ist, sagt er nicht alles aus. Autos in gutem Zustand sind in der
          Regel mehr wert als solche, die weniger gepflegt wurden. Ein Fahrzeug,
          das sowohl innen als auch außen gut gepflegt ist und sich in nahezu
          perfektem Zustand befindet, kann attraktiver sein als eines mit etwas
          weniger Kilometern.
        </p>
      </>
    ),
  },
  {
    question: "Garantien",
    answer: (
      <>
        <p>
          Die Absicherung durch eine Herstellergarantie bietet Käufern
          zusätzliche Sicherheit: Falls es zu mechanischen oder elektrischen
          Problemen kommt, die nicht mit einem Unfall zusammenhängen, werden
          diese kostenlos behoben. Die meisten Neuwagen werden mit einer
          Herstellergarantie von mindestens drei Jahren verkauft. Diese Garantie
          bleibt in der Regel auch dann gültig, wenn das Auto in diesem Zeitraum
          als Gebrauchtwagen weiterverkauft wird. Eine gültige Garantie wirkt
          sich positiv auf den Wert deines Autos aus.
        </p>
      </>
    ),
  },
  {
    question: "Farbe",
    answer: (
      <>
        <p>
          Die Farbe eines Fahrzeugs kann seine Attraktivität und damit auch den
          Wiederverkaufswert beeinflussen. Viele professionelle Käufer
          bevorzugen Autos in beliebten Farben wie Schwarz, Grau oder Blau, was
          sich positiv auf die Fahrzeugbewertung auswirken kann – besonders,
          wenn sich die Farbvorlieben der Käufer im Laufe der Zeit ändern.
        </p>
      </>
    ),
  },
  {
    question: "Sonderausstattung",
    answer: (
      <>
        <p>
          Sonderausstattungen können den Wert eines Autos oft steigern. Extras
          wie Ausstattungspakete, Ledersitze und hochwertige Soundsysteme sorgen
          normalerweise dafür, dass dein Gebrauchtwagen bei der
          Fahrzeugbewertung mehr wert ist.
        </p>
      </>
    ),
  },
  {
    question: "Technologie",
    answer: (
      <>
        <p>
          Mit den Fortschritten bei Sicherheits-, Leistungs- und
          Komforttechnologien erzielen Autos mit den neuesten und gefragtesten
          Features weiterhin höhere Preise.
        </p>
      </>
    ),
  },
];

export const fragenDreiData = [
  {
    question: "Warum sollte ich eine Fahrzeugbewertung durchführen? ",
    answer: (
      <>
        <p>
          Auch wenn du noch nicht bereit bist, dein Auto zu verkaufen, kann es
          hilfreich sein, seinen potenziellen Wert im Blick zu behalten. So
          bekommst du eine Vorstellung davon, wie sich der Wert in Zukunft
          entwickeln könnte – und kannst besser entscheiden, wann ein Verkauf
          sinnvoll ist.
        </p>

        <p>
          Dein Fahrzeug gehört wahrscheinlich zu deinen wertvollsten
          Besitztümern. Die Preisentwicklung zu verfolgen, hilft dir, deine
          finanzielle Situation besser einzuschätzen. Mit Autoeinfachlos kannst
          du einfach und kostenlos dein Auto bewerten lassen und seinen Wert
          über die Zeit verfolgen.
        </p>
      </>
    ),
  },
  {
    question: "Wie viel ist mein Auto wert?",
    answer: (
      <>
        <p>
          Mit Autoeinfachlos kannst du schnell und unkompliziert herausfinden,
          wie viel dein Auto wert ist. Unser Tool zur Autobewertung nutzt
          intelligente Technologie und aktuelle Marktdaten, sodass du stets
          einen genauen und aktuellen Schätzwert für den Verkaufspreis erhältst.
          Gib einfach deine Fahrgestellnummer und die Kilometerzahl ein, um den
          aktuellen Wert deines Autos zu erfahren.
        </p>

        <p>
          Eine Fahrzeugbewertung und das Nachverfolgen von Preisänderungen kann
          herausfordernd sein, da viele Faktoren wie Kilometerstand, Zustand,
          Schäden und Wartungshistorie eine Rolle spielen. Mit unserem
          Fahrzeugbewertungstool bleibst du stets auf dem Laufenden, wenn sich
          der Wert deines Autos ändert – so kannst du zum besten Zeitpunkt für
          dich verkaufen.
        </p>
      </>
    ),
  },
  {
    question: "Was ist die beste Plattform zur Autobewertung?",
    answer: (
      <>
        <p>
          Es gibt zahlreiche Websites, die eine aktuelle Fahrzeugbewertung über
          Preisrechner anbieten. Allerdings liefert nicht jede Plattform eine
          neutrale Fahrzeugbewertung. Wenn du eine Bewertung über eine
          Ankaufsplattform durchführst, erhältst du oft deren Ankaufspreis als
          Bewertung deines Fahrzeugs.
        </p>
        <p>
          <strong>Autoeinfachlos</strong>&nbsp;hingegen bietet eine objektive
          Bewertung, die auf aktuellen Trends basiert. Das bedeutet, dass du
          eine Echtzeit-Bewertung erhältst, die die Kauf-, Verkaufs- und
          Angebotstransaktionen des österreichischen Automarkts widerspiegelt.
        </p>

        <p>
          <strong>Das Beste:</strong>&nbsp;Bei uns erhältst du kostenlos
          monatliche Berichte und eine aktualisierte Autobewertung. So behältst
          du den Wert deines Fahrzeugs Monat für Monat im Blick.
        </p>
      </>
    ),
  },
  {
    question:
      "Auto Bewerten bei Autoeinfachlos im Vergleich zu anderen Anbietern",
    answer: (
      <>
        <p>
          Viele Ankaufsplattformen, wie beispielsweise „WirKaufenDeinAuto“,
          bieten Fahrzeugbewertungen an, zeigen dabei jedoch oft nur ihren
          eigenen Ankaufspreis und nicht den tatsächlichen Marktwert des
          Fahrzeugs. Bei Autoeinfachlos verfolgen wir einen anderen Ansatz: Wir
          kaufen keine Fahrzeuge an, sondern vermitteln diese an ein
          österreichweites Netzwerk von Händlern.
        </p>
        <p>
          Unsere Autobewertung basiert auf aktuellen Marktdaten. Unsere Software
          analysiert laufend den Markt und überprüft, welche ähnlichen Fahrzeuge
          derzeit verkauft werden. Dabei berücksichtigen wir verschiedene
          Faktoren wie Kilometerstand, Baujahr, Modell und die spezifische
          Ausstattung deines Fahrzeugs. Mithilfe der Fahrgestellnummer
          berücksichtigen wir dabei auch die Sonderausstattung deines Autos. So
          erhältst du eine umfassende und realistische Bewertung, die den
          tatsächlichen Marktwert widerspiegelt.
        </p>
        <p>
          Wenn du dich für einen Verkauf entscheidest, kannst du einfach weitere
          Informationen zu deinem Fahrzeug angeben. Wir listen es dann auf
          unserer Auktionsplattform, wo es an den Händler mit dem höchsten Gebot
          vermittelt wird. So erhältst du den bestmöglichen Preis – transparent
          und marktgerecht.
        </p>

        <p>
          <strong>Nur bei uns:</strong> Bei Autoeinfachlos erhältst du{" "}
          <strong>kostenlos monatliche Berichte</strong> und eine aktualisierte
          Autobewertung. So behältst du den Wert deines Fahrzeugs Monat für
          Monat im Blick.
        </p>
      </>
    ),
  },
  {
    question: "Wie genau sind die Bewertungen von Autoeinfachlos?",
    answer: (
      <>
        <p>
          Die Bewertungen von Autoeinfachlos basieren auf umfassenden
          Marktdaten, die sowohl aktuelle Händlerverkäufe als auch private
          Fahrzeugverkäufe auf verschiedenen Plattformen berücksichtigen. Unsere
          Software analysiert laufend den Markt und bezieht dabei Faktoren wie
          Kilometerstand, Baujahr, Modell und Sonderausstattungen deines
          Fahrzeugs mithilfe der Fahrgestellnummer ein, um dir eine präzise und
          realistische Bewertung zu bieten. Die Preise werden in Echtzeit
          angepasst, sodass du stets einen geschätzten Verkaufspreis erhältst,
          der auf den aktuellsten Angeboten für vergleichbare Fahrzeuge basiert.
        </p>
      </>
    ),
  },

  {
    question: "Welche Informationen benötige ich für eine Fahrzeugbewertung?",
    answer: (
      <>
        <p>
          Für eine schnelle und genaue Bewertung bei Autoeinfachlos brauchst du
          lediglich die Fahrgestellnummer und den Kilometerstand deines Autos.
          Unsere Datenbank greift auf die Informationen aus tausenden
          erfolgreichen Verkäufen auf dem österreichischen Markt zu und erledigt
          den Rest! Die Daten werden täglich und in Echtzeit aktualisiert,
          sodass du eine verlässliche Bewertung erhältst. Beachte jedoch, dass
          sich Bewertungen aufgrund vieler Faktoren häufig ändern können; ein
          präziser Fahrzeugwert heute kann nächsten Monat bereits anders
          ausfallen.
        </p>
      </>
    ),
  },
  {
    question: "Wie wird der Wert eines Autos berechnet?",
    answer: (
      <>
        <p>
          Der Wert eines Fahrzeugs basiert auf vielen Faktoren, darunter Alter,
          Zustand, Kilometerstand, Beliebtheit auf dem Markt und mehr. Alle
          Neuwagen verlieren unmittelbar an Wert, sobald sie gekauft werden,
          selbst wenn sie kaum genutzt wurden. In den ersten Jahren sinkt der
          Wert meist besonders schnell, und Fahrzeuge verlieren bis zu einem
          Drittel ihres ursprünglichen Preises – abhängig davon, wie begehrt sie
          für Käufer sind.
        </p>

        <p>
          Zunächst berücksichtigt die Bewertung das Alter, den Kilometerstand
          und die Ausstattung des Autos. Ein vier Jahre alter Ford Fiesta mit
          Benzinmotor und hochwertiger Ausstattung könnte beispielsweise
          zwischen 75 % und 80 % seines ursprünglichen Kaufpreises erzielen.
          Anschließend wird der Zustand genauer betrachtet. Bei minimalem
          Verschleiß erreicht das gleiche Auto den oberen Bereich dieser
          Preisspanne oder sogar mehr, da Fahrzeuge in nahezu perfektem Zustand
          auf dem Gebrauchtwagenmarkt besonders selten und daher wertvoller
          sind.
        </p>
      </>
    ),
  },
  {
    question: "Wie funktioniert die Fahrzeugbewertung?",
    answer: (
      <>
        <p>
          Fahrzeugbewertungen sind schwer vorherzusagen, da die Wertminderung
          eine dynamische Entwicklung und kein linearer Prozess ist. Der Wert
          eines Autos verändert sich nicht jedes Jahr gleichmäßig, und externe
          Markteinflüsse können großen Einfluss darauf haben, ob ein Auto an
          Wert verliert oder gewinnt. Ein Beispiel dafür sind die
          Neuwagenengpässe im Jahr 2021, durch die viele fast neue und wenig
          gefahrene Autos sogar im Wert gestiegen sind und teurer wurden als ihr
          ursprünglicher Kaufpreis.
        </p>
      </>
    ),
  },
  {
    question: "Wozu brauche ich die FIN, ehemals Fahrgestellnummer?",
    answer: (
      <>
        <p>
          Die FIN – auch Fahrzeugidentifikationsnummer genannt – hilft dabei,
          jedes Auto eindeutig zu erkennen, egal welcher Hersteller. Mit der FIN
          kann man schnell und genau herausfinden, welche Ausstattung das Auto
          hat. Die 17-stellige Nummer findest du im Typenschein, in den Teilen 1
          und 2 der Zulassungsbescheinigung und direkt am Auto.
        </p>
      </>
    ),
  },
  {
    question: "Was wird im Bewertungsbericht enthalten sein?",
    answer: (
      <>
        <p>
          Der kostenlose Bewertungsbericht von Autoeinfachlos liefert dir alle
          wichtigen Basisdaten zur&nbsp;
          <strong>Fahrzeugbewertung:</strong>&nbsp;Marke, Modell, Baujahr,
          Neupreis, Kraftstoffart, Erstzulassung, Serienausstattung sowie den
          Händler-Verkaufs- und -Einkaufswert. Diese Informationen stehen neben
          dem aktuellen Marktwert, der auf Echtzeit-Verkaufsdaten und den
          neuesten Marktentwicklungen basiert. So kannst du dein&nbsp;
          <strong>Auto bewerten</strong>&nbsp;lassen und eine verlässliche
          Einschätzung erhalten, wann der beste Zeitpunkt für einen Verkauf ist.
        </p>
      </>
    ),
  },
  {
    question:
      "Werden meine Bewertungen in meinem Autoeinfachlos-Konto gespeichert?",
    answer: (
      <>
        <p>
          Ja, alle Bewertungen, die du bei Autoeinfachlos durchführst, werden in
          deinem kostenlosen Konto gespeichert. Du kannst bis zu sechs Fahrzeuge
          hinzufügen und deren Bewertungen direkt in deinem Konto einsehen.
          Zusätzlich kannst du festlegen, ob du monatliche Benachrichtigungen
          über den aktuellen Wert deines Fahrzeugs erhalten möchtest. Darüber
          hinaus hast du jederzeit die Möglichkeit, kostenlos eine neue
          Bewertung deines Fahrzeugs durchzuführen, um stets den aktuellen
          Marktwert zu kennen.
        </p>
      </>
    ),
  },
  {
    question: "Was passiert nach der Autobewertung?",
    answer: (
      <>
        <p>
          Wenn du nach der Autobewertung an einem Verkauf interessiert bist,
          klicke einfach auf „Auto verkaufen“ und lade weitere Informationen zum
          aktuellen Zustand deines Fahrzeugs hoch. Anschließend wirst du
          gebeten, Fotos von deinem Auto bereitzustellen. Sobald alles
          vollständig ist, stellen wir dein Fahrzeug unserem Händlernetzwerk zur
          Verfügung und starten eine 24-Stunden-Online-Auktion. Nach Ablauf der
          Auktion erhältst du das Höchstgebot und kannst dein Fahrzeug direkt
          verkaufen.
        </p>

        <p>
          Unsere geprüften Händler holen dein Fahrzeug kostenlos vor Ort ab und
          veranlassen eine Sofortüberweisung – sicher und unkompliziert.
        </p>
      </>
    ),
  },
  {
    question: "Wie sieht die Prognose für den österreichischen Automarkt aus?",
    answer: (
      <>
        <p>
          Der Gebrauchtwagenmarkt in Österreich ist mehr als dreimal so groß wie
          der Neuwagenmarkt, und ein Auto hat im Durchschnitt 2-3 Besitzer
          während seiner Lebensdauer (laut einer Umfrage von Statista aus dem
          Jahr 2023). Diese Zahl bleibt relativ konstant, obwohl die
          Fahrzeugpreise je nach Marktbedingungen schwanken können. So stiegen
          beispielsweise die Gebrauchtwagenpreise im Jahr 2023 im Durchschnitt
          um 5 % im Vergleich zum Vorjahr.
        </p>

        <p>
          Um den bestmöglichen Preis für Ihr Fahrzeug zu erzielen, ist es
          wichtig, den optimalen Verkaufszeitpunkt zu wählen. Dies erfordert ein
          Verständnis der aktuellen Markttrends und Preisentwicklungen.
          Angesichts der Schwankungen im Gebrauchtwagenmarkt ist es ratsam, den
          Wert Ihres Fahrzeugs regelmäßig zu überprüfen und die
          Marktentwicklungen im Auge zu behalten.
        </p>
      </>
    ),
  },
];
